import { useEffect, useState } from "react";
import { NOVIDADES, type Novidade } from "./lista";

// O que cada pessoa já viu fica no navegador dela: é só para o aviso de "novo".
// Navegador sem armazenamento (aba anônima, bloqueio) mostra tudo como novo, sem quebrar.

const EVENTO = "georanking:novidades-vistas";
const chave = (usuario?: string | number | null) => `novidades-vistas:${usuario ?? "anonimo"}`;

export const lerVistas = (usuario?: string | number | null): Set<string> => {
  try {
    const salvo = window.localStorage.getItem(chave(usuario));
    return new Set(salvo ? (JSON.parse(salvo) as string[]) : []);
  } catch {
    return new Set();
  }
};

export const naoVistas = (usuario?: string | number | null, lista: Novidade[] = NOVIDADES): Novidade[] => {
  const vistas = lerVistas(usuario);
  return lista.filter((n) => !vistas.has(n.id));
};

export const marcarTodasVistas = (usuario?: string | number | null, lista: Novidade[] = NOVIDADES) => {
  try {
    window.localStorage.setItem(chave(usuario), JSON.stringify(lista.map((n) => n.id)));
  } catch {
    // sem armazenamento: o aviso volta na próxima visita, nada mais
  }
  window.dispatchEvent(new Event(EVENTO));
};

/** Quantas novidades a pessoa ainda não viu; atualiza quando ela abre o mural. */
export const useNovidadesNaoVistas = (usuario?: string | number | null): Novidade[] => {
  const [pendentes, setPendentes] = useState<Novidade[]>(() => naoVistas(usuario));
  useEffect(() => {
    const atualizar = () => setPendentes(naoVistas(usuario));
    atualizar();
    window.addEventListener(EVENTO, atualizar);
    window.addEventListener("storage", atualizar);
    return () => {
      window.removeEventListener(EVENTO, atualizar);
      window.removeEventListener("storage", atualizar);
    };
  }, [usuario]);
  return pendentes;
};
